export function contain(url: string, maxWidth = 800, maxHeight = 600, quality = 80) {
    return `${url}?ops=gravity("center"),maxcontain(${maxWidth},${maxHeight}),quality(${quality})`;
}

export function mediaServerImage(hostname: string, bucket: string, id: string) {
    return `https://${hostname}/v3/re/${bucket}/${id}`;
}

export function mediaServerCatalogImage(
    hostname: string,
    namespace: string,
    id: number | string,
    maxWidth = 48,
    maxHeight = 48,
    noOps = false,
) {
    if (noOps) {
        return `https://${hostname}/v3/catalog/${namespace}/${id}`;
    }
    return `https://${hostname}/v3/catalog/${namespace}/${id}?ops=fit(${maxWidth},${maxHeight})`;
}

export function mediaServerPlaylistImage(
    hostname: string,
    userId: string,
    id: string,
    maxWidth = 224,
    maxHeight = 224,
) {
    return `https://${hostname}/v3/user/${userId}/collection/${id}?ops=fit(${maxWidth},${maxHeight})`;
}

export function stripNamespace(tag?: string | null) {
    return tag ? tag.split("/")[1] : tag;
}

export enum AgentOSType {
    WINDOWS,
    IOS,
    ANDROID,
}

export const getOsTypeFromAgent = () => {
    if (typeof window !== "undefined") {
        const agent = window.navigator.userAgent;

        if (!agent) {
            return null;
        }

        if (!window.MSStream && /ipad|iphone|ios/i.test(agent)) {
            return AgentOSType.IOS;
        }

        if (/android/i.test(agent)) {
            return AgentOSType.ANDROID;
        }

        if (/windows/i.test(agent)) {
            return AgentOSType.WINDOWS;
        }
    }

    return null;
};
